export default __webpack_public_path__ + "static/globe-aa2fc84b8f9961c213bbf93a69cc4c5b.png";